// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1Na1P","file":"styles_file__364vd"};